<app-table
    [pageSize]="7"
    [allowedPageSizes]="[7]"
    [showPageSizeSelector]="false"
    [data]="complianceCoursesQualificationData"
    [columns]="complianceCoursesQualificationColumns"
    (onRowClick)="onCourseClick($event)"
></app-table>